import type { PlayerId } from "@kikik/mahjong-core";
import { useI18n } from "../i18n";
import type { LogEntry } from "../game/eventLog";
import { Drawer } from "./Drawer";

export interface EventLogProps {
  entries: readonly LogEntry[];
  nameFor: (playerId: PlayerId) => string;
}

/** Secondary history: folded away by default, one click from the table. */
export function EventLog({ entries, nameFor }: EventLogProps) {
  const { t, tm } = useI18n();
  const recent = entries.slice(-16).reverse();
  return (
    <Drawer
      className="panel log"
      title={t("log.title")}
      note={String(entries.length)}
      testId="log-panel"
    >
      {recent.length === 0 ? (
        <p className="muted">{t("log.empty")}</p>
      ) : (
        <ol className="log__list">
          {recent.map((entry) => (
            <li key={entry.id} className={`log__item log__item--${entry.tone}`}>
              {tm(entry.message, { playerName: nameFor })}
            </li>
          ))}
        </ol>
      )}
    </Drawer>
  );
}
